export default "__VITE_ASSET__CHn2DMds__"